var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50.927,
    height: 32.998,
    viewBox: "0 0 50.927 32.998",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "van",
    transform: "translate(-1.005 -9.453)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_109130",
    "data-name": "Path 109130",
    d: "M30.761,12.562v23.2A1.064,1.064,0,0,1,29.7,36.821H19.566a7.238,7.238,0,0,0-14.443,0H4.114a3.114,3.114,0,0,1-3.109-3.109V12.562A3.107,3.107,0,0,1,4.114,9.453H27.652A3.107,3.107,0,0,1,30.761,12.562Zm20.662,10.3-4.69-6.717a3.149,3.149,0,0,0-2.589-1.327H32.884V35.76A3.1,3.1,0,0,1,32.7,36.8a.935.935,0,0,0,.181.021h1.783A7.233,7.233,0,0,1,49.1,36.811a3.036,3.036,0,0,0,2.833-2.982V24.5A2.967,2.967,0,0,0,51.423,22.866ZM36.98,25.233V19.98h6.134l3.672,5.264Z",
    transform: "translate(0 0)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1436",
    "data-name": "Ellipse 1436",
    cx: 5.129,
    cy: 5.129,
    r: 5.129,
    transform: "translate(7.218 32.193)",
    fill: "#606060"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_1437",
    "data-name": "Ellipse 1437",
    cx: 5.129,
    cy: 5.129,
    r: 5.129,
    transform: "translate(36.754 32.193)",
    fill: "#606060"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVan);
export default __webpack_public_path__ + "static/media/van.f5fa78d1e7e7ddede27b4f285f58a834.svg";
export { ForwardRef as ReactComponent };